module.exports = __webpack_public_path__ + "img/1115860495.e81b0d86.png";